<div class="u-color-muted" *ngIf="!!move">
    <p>{{ move.user?.formattedName || move.user?.email }} ({{ interviewee | i18nKey: i18nKeyInterviewee | translate }})</p>
    <p>{{ move.user?.formattedMovingAddress || move.user?.formattedCurrentAddress }}</p>
    <p>{{ move.realEstateGroup?.name }} - {{ move.realEstateAgent?.firstName }} {{ move.realEstateAgent?.lastName }}</p>
</div>
